/* eslint-disable import/prefer-default-export */

import { ReleaseNoteType } from '../constants'

export type ReleaseNoteTypeOption = {
  value: ReleaseNoteType
  label: string
}

export const releaseNoteTypeOptions: ReleaseNoteTypeOption[] = [
  {
    value: ReleaseNoteType.INTERNAL_ONLY,
    label: 'Internal',
  },
  {
    value: ReleaseNoteType.PUBLIC,
    label: 'Public',
  },
  {
    value: ReleaseNoteType.DRAFT,
    label: 'Draft',
  },
]
